<div class="d-flex flex-column" [appSpinner]="loadingState === 'in-progress'" [style.minHeight]="'60px'">
  <div dragula="{{mode === SideSheetListModes.DRAG ? dragGroupName : null}}" style="min-height:50px;" class="flex-grow-1"
       [dragulaModel]="mode === SideSheetListModes.DRAG ? draggableModel : null" (dragulaModelChange)="draggableModel = mode === SideSheetListModes.DRAG ? $event : null">
    <ng-content></ng-content>
  </div>
  <div class="text-center" *ngIf="showMoreButton">
    <button type="button" class="btn btn-secondary m-3" (click)="onShowMore()">Show more</button>
  </div>
</div>
